/*
 * Saigu Cosmetics · Test de visagismo · TEXTOS Y PRODUCTOS
 * ------------------------------------------------------------------
 * Este es el único archivo que hay que tocar para cambiar los textos de
 * los resultados o los productos que se recomiendan en cada paso.
 *
 * Estructura de cada tipo:
 *   nombre     → nombre del tipo (p. ej. «Ovalado»)
 *   resumen    → frase corta que aparece en la selección manual
 *   intro      → párrafo bajo el título del resultado
 *   pasos      → lista de consejos. Cada paso tiene:
 *       pregunta   → título del paso
 *       texto      → párrafo (opcional)
 *       lista      → viñetas (opcional)
 *       categorias → categorías de producto del editor del tema (opcional):
 *                    bronceador, bronceador_frio, colorete, iluminador,
 *                    sombras_mate, sombras_satinadas, eyeliner, lapiz_ojos,
 *                    perfilador_labios, labial, gloss
 *       productos  → productos concretos para ESTE paso (opcional), por su
 *                    «handle»: la última parte de la URL del producto.
 *                    Ej.: saigucosmetics.com/products/bronceador-greta → 'bronceador-greta'
 *                    Si un paso tiene «productos», se muestran esos y se
 *                    ignoran sus «categorias».
 *
 * Reglas para no romper el archivo:
 *   · Los textos van entre comillas simples: 'así'. Si un texto necesita un
 *     apóstrofo, escríbelo como \' (p. ej. 'l\'eau').
 *   · Cada elemento termina en coma, salvo el último de su lista.
 *   · Las claves (ovalado, cuadrado, grandes…) no se cambian: son las que usa el análisis.
 */
window.SaiguVisagismoTextos = {
  areas: {
    rostro: {
      titulo: 'Rostro',
      subtitulo: 'Colorete, bronceador e iluminador según la forma del rostro',
      tipos: {
        ovalado: {
          nombre: 'Ovalado',
          resumen: 'Rostro armónico, algo más largo que ancho.',
          intro: 'Es el rostro en el que buscamos mantener y potenciar su armonía natural. No queremos modificar su estructura, sino realzarla.',
          pasos: [
            { pregunta: '¿Dónde aplicar el bronceador?',
              texto: 'Realza las zonas del rostro que se broncean de forma natural:',
              lista: [
                'La zona superior a la hendidura del pómulo: empieza en la raíz del pelo y baja en diagonal hacia la comisura de la boca. Deja de aplicar más o menos a la altura del final del ojo.',
                'La raíz del pelo en la frente y la sien.',
                'Los laterales del puente de la nariz, para perfilarla sutilmente.',
                'La cuenca y el tercio externo del ojo, difuminando hacia la sien.'
              ],
              productos: ['bronzer', 'melting-bronzer'] },
            { pregunta: '¿Dónde aplicar el colorete?',
              texto: 'El pómulo forma una pirámide de la oreja a la nariz. Busca el pico de esa pirámide y coloca ahí el colorete, en la parte alta de la mejilla. Así realzas los volúmenes naturales del rostro.',
              productos: ['colorete', 'melting-blush', 'colorete-en-polvo-mate-radiante'] },
            { pregunta: '¿En qué dirección difuminarlo?',
              texto: 'Difumínalo hacia el bronceador, no hacia la sien. Tu rostro tiene cierta verticalidad y, si elevas mucho el colorete, la cara parecerá más alargada.' },
            { pregunta: '¿Dónde colocar el iluminador?',
              texto: 'En las zonas más elevadas del rostro:',
              lista: [
                'La parte alta del pómulo.',
                'La punta de la nariz, justo donde incidiría una luz cenital, para respingarla.',
                'El arco de cupido.',
                'El arco de la ceja.'
              ],
              productos: ['iluminador'] }
          ]
        },
        cuadrado: {
          nombre: 'Cuadrado',
          resumen: 'Frente y mandíbula marcadas; rostro más bien corto.',
          intro: 'Tiene facciones definidas, con mayor protagonismo en la frente y la mandíbula, y poca verticalidad. Para conseguir el famoso «efecto buena cara» suavizamos esos ángulos y alargamos visualmente el rostro.',
          pasos: [
            { pregunta: '¿Cómo aplicar el colorete?',
              texto: 'En este rostro los pómulos suelen tener menos protagonismo, así que el colorete es lo que usarás para realzarlos. Colócalo bastante elevado en el pómulo y difumínalo en dirección a la sien para crear verticalidad y volumen.',
              productos: ['colorete', 'melting-blush', 'colorete-en-polvo-mate-radiante'] },
            { pregunta: '¿Cómo aplicar el bronceador para suavizar las facciones?',
              texto: 'Aquí sí usamos el bronceador para «modelar» el rostro. Concentra la mayor cantidad de producto en:',
              lista: [
                'Los laterales de la frente y la sien, sin tocar la zona central de la raíz del pelo.',
                'Los laterales de la mandíbula. Ve con cuidado de no pasarte y usa un tono más bien frío, como Greta o Gia, para que parezca una sombra ligera y no una mancha de producto.',
                'La parte superior de la hendidura del pómulo, en dirección a la sien. Aquí no será protagonista: deja espacio al colorete.'
              ],
              productos: ['bronzer', 'melting-bronzer'] },
            { pregunta: '¿Dónde colocar el iluminador para aportar dimensión?',
              texto: 'En las zonas más elevadas del rostro, pero por debajo de los productos de mejillas, para una luz más natural y menos exagerada:',
              lista: [
                'Une la zona alta del pómulo con el arco de la ceja para crear una estructura más redondeada.',
                'En la nariz, aplica en la punta y también un poco en el puente, en vertical.',
                'Como las facciones suelen estar más juntas en el centro, ilumina el lagrimal para aportar amplitud.'
              ],
              productos: ['iluminador'] },
            { pregunta: '¿Qué conviene evitar?',
              texto: 'Si buscas armonía, evita las líneas angulosas y los maquillajes muy estructurados: refuerzan aún más los rasgos «duros» de este rostro. Si por el contrario quieres un look potente, haz justo lo contrario y conseguirás un maquillaje con muchísima fuerza.' }
          ]
        },
        triangular: {
          nombre: 'Triangular',
          resumen: 'Mandíbula ancha y definida; frente y sienes más estrechas.',
          intro: 'Tiene una base ancha y definida en la mandíbula, mientras que la frente y las sienes son sensiblemente más estrechas. Suavizamos la contundencia del tercio inferior y aportamos amplitud arriba para equilibrar el conjunto.',
          pasos: [
            { pregunta: '¿Cómo equilibrar las proporciones con el bronceador?',
              lista: [
                'Concentra la mayor oscuridad en los laterales de la mandíbula, con un tono más bien frío como Greta o Gia, para que parezca una sombra ligera.',
                'Marca ligeramente el nacimiento del pelo en la parte central de la frente y deja despejadas las sienes, para aportar luminosidad y volumen en los laterales.',
                'La zona superior a la hendidura del pómulo: empieza en la raíz del pelo y baja en diagonal hacia la comisura de la boca, hasta más o menos la altura del final del ojo.'
              ],
              productos: ['bronzer', 'melting-bronzer'] },
            { pregunta: '¿Y el colorete?',
              texto: 'Colócalo bastante elevado en el pómulo y difumínalo en dirección a la sien, para crear verticalidad y volumen.',
              productos: ['colorete', 'melting-blush', 'colorete-en-polvo-mate-radiante'] },
            { pregunta: '¿Dónde aplicar el iluminador?',
              texto: 'Juega con la luz en la parte superior del rostro y en sus zonas más altas: el arco de la ceja, la parte alta del pómulo, la punta y el puente de la nariz y los lagrimales.',
              productos: ['iluminador'] }
          ]
        },
        redondo: {
          nombre: 'Redondo',
          resumen: 'Contornos suaves y curvos; casi tan ancho como largo.',
          intro: 'Sus contornos son suaves y curvos: la anchura y la longitud son prácticamente iguales y no hay ángulos marcados en la mandíbula ni en la frente. Podemos aportar dimensión y estructura o abrazar la frescura y juventud que transmite.',
          pasos: [
            { pregunta: '¿Cómo colocar el bronceador?',
              texto: 'Aquí sí buscamos enfatizar las facciones y crear verticalidad. Aplícalo en:',
              lista: [
                'Los laterales de la frente, la zona central y la sien, intentando crear un ligero ángulo.',
                'Los laterales de la mandíbula. Ve con cuidado de no pasarte y usa un tono más bien frío, como Greta o Gia, para que parezca una sombra ligera y no una mancha de producto.',
                'La parte superior de la hendidura del pómulo, en dirección a la sien, para crear verticalidad y estructura.'
              ],
              productos: ['bronzer', 'melting-bronzer'] },
            { pregunta: '¿Qué evitar con el colorete?',
              texto: 'Marcar la manzana de la mejilla es el némesis de este rostro, porque redondea aún más las facciones. Aplica el producto hacia la parte trasera del pómulo.',
              productos: ['colorete', 'melting-blush', 'colorete-en-polvo-mate-radiante'] },
            { pregunta: '¿Dónde aplicar el iluminador?',
              texto: 'En las zonas más elevadas, esta vez por encima de los productos de mejillas, para una luz más intensa:',
              lista: [
                'Separa la zona alta del pómulo del arco de la ceja para crear una estructura más estilizada.',
                'En la nariz, aplica en la punta y también un poco en el puente, en vertical.',
                'Ilumina el lagrimal para aportar amplitud, ya que las facciones suelen estar más juntas en el centro.'
              ],
              productos: ['iluminador'] }
          ]
        }
      }
    },
    ojos: {
      titulo: 'Ojos',
      subtitulo: 'Eyeliner y sombras según la forma del ojo',
      tipos: {
        grandes: {
          nombre: 'Grandes',
          resumen: 'Ojos amplios y con tendencia a ser redondos.',
          intro: 'Los ojos grandes resultan muy atractivos. Si son grandes respecto al resto del rostro, conviene tener en cuenta algunos puntos.',
          pasos: [
            { pregunta: '¿Cómo aplicar las sombras para equilibrar la mirada?',
              texto: 'Suelen tender a ser redondos, así que difumina las sombras fuera del perímetro del ojo, en dirección a la sien.',
              productos: ['sombra-liquida-one-touch', 'paleta-de-sombras'] },
            { pregunta: '¿Qué eyeliner favorece más?',
              texto: 'Los delineados difuminados son los que más ayudan a dar forma y estructura. Un delineado gráfico solo atraería aún más la mirada a esta zona.' },
            { pregunta: '¿Línea superior, inferior o ambas?',
              texto: 'Ambas. La línea del agua cierra el ojo (y un ojo grande lo soporta fácilmente) y la superior lo estructura, así que al maquillar las dos enmarcas la mirada a la perfección. Si buscas algo más natural o tienes un contraste medio o bajo, usa tonos medios para no endurecer la mirada.',
              productos: ['lapiz-de-ojos-delineado-infinito'] },
            { pregunta: '¿Qué técnicas potencian la mirada sin agrandar más el ojo?',
              texto: 'Los ahumados un poco rasgados y los foxy eyes, siempre en mate o en tonos satinados, para no aportar luz en exceso.' }
          ]
        },
        pequenos: {
          nombre: 'Pequeños',
          resumen: 'Buscamos amplitud, luminosidad y apertura.',
          intro: 'Al maquillar este tipo de ojos buscamos crear amplitud, luminosidad y apertura.',
          pasos: [
            { pregunta: '¿Cómo usar las sombras para dar más amplitud?',
              texto: 'Aplica un color claro en los dos tercios internos del párpado móvil y difumínalo por encima de la cuenca natural, hasta el párpado fijo, creando una cuenca falsa. Evita las sombras oscuras y trabaja el tercio externo y la parte superior de la cuenca.',
              productos: ['sombra-liquida-one-touch', 'paleta-de-sombras'] },
            { pregunta: '¿Qué eyeliner favorece más?',
              texto: 'Un delineado difuminado o un gráfico muy delicado y fino.' },
            { pregunta: '¿Dónde debe terminar el eyeliner?',
              texto: 'Siempre dentro del límite de la ceja, para que no llame más la atención el delineado que el ojo. Y nunca lo empieces antes del centro del iris: si lo empiezas desde el lagrimal, el ojo parecerá aún más pequeño.' },
            { pregunta: '¿Qué colores y puntos de luz abren la mirada?',
              texto: 'Los colores claros (vainillas, rosas pálidos, satinados) en el lagrimal, la cuenca interna y el arco superciliar dan una mirada más luminosa. Un poco de lápiz vainilla en la línea del agua da sensación de mayor amplitud.',
              productos: ['lapiz-de-ojos-delineado-infinito'] },
            { pregunta: '¿Qué errores evitar?',
              texto: 'Los colores oscuros, los ahumados muy marcados, marcar las líneas de agua con colores dramáticos y no aportar suficiente luz.' }
          ]
        },
        encapotados: {
          nombre: 'Encapotados',
          resumen: 'El párpado fijo oculta el móvil al abrir los ojos.',
          intro: 'El párpado fijo oculta el párpado móvil al abrir los ojos. La clave es crear una falsa cuenca y elevar visualmente la mirada.',
          pasos: [
            { pregunta: '¿Cómo colocar las sombras para que se vean con el ojo abierto?',
              texto: 'Trabaja siempre con el ojo abierto y la mirada al frente, que es la postura natural del ojo.' },
            { pregunta: '¿Dónde situar la transición y la profundidad?',
              lista: [
                'La transición, en el párpado fijo y el tercio externo del ojo, elevando la parte final.',
                'La profundidad, siguiendo la sombra anterior como referencia: por encima de la cuenca natural (creando una nueva) y en el tercio externo. No tapes la transición: se tienen que ver ambas.',
                'Por debajo de la cuenca que has creado, en los dos tercios interiores, una sombra clarita (puede ser satinada) para aportar luz y abrir la mirada.'
              ],
              productos: ['sombra-liquida-one-touch', 'paleta-de-sombras'] },
            { pregunta: '¿Cómo hacer el eyeliner para que el párpado no «se coma» la línea?',
              texto: 'Con el ojo abierto, ya sea difuminado o gráfico, haz un delineado en punta de flecha: saca el rabillo en vertical y conéctalo con el centro del ojo.' },
            { pregunta: '¿Qué tipo de delineado funciona mejor?',
              texto: 'Normalmente les favorece más un delineado difuminado, porque ayuda a ocultar el pliegue y es más fácil de trabajar. Un gráfico delicado y fino también puede quedar bien.' }
          ]
        },
        prominentes: {
          nombre: 'Prominentes',
          resumen: 'Ojos que tienden a salir hacia fuera (globulosos).',
          intro: 'Estos ojos tienden a salir hacia fuera, así que buscamos dar profundidad.',
          pasos: [
            { pregunta: '¿Cómo equilibrar el volumen del ojo con las sombras?',
              texto: 'Uno de los mejores recursos es el ahumado, porque aporta mucha profundidad.',
              productos: ['sombra-liquida-one-touch', 'paleta-de-sombras'] },
            { pregunta: '¿Qué acabados funcionan mejor?',
              texto: 'Siempre mate. No les sientan bien las estructuras muy luminosas, así que incluso las zonas más claras, como el lagrimal o el arco de la ceja, se trabajan en mate.' },
            { pregunta: '¿Cómo hacer el eyeliner?',
              texto: 'Pueden llevar delineados difuminados y también gráficos: estos, al aportar un color más plano y opaco, ayudan a profundizar la mirada.' },
            { pregunta: '¿Dónde concentrar más profundidad?',
              texto: 'Trabaja las líneas de agua al completo y da bastante información a la parte central del ojo, más o menos donde está el iris. Al tender a ser grandes, suelen tolerar bien los colores oscuros.',
              productos: ['lapiz-de-ojos-delineado-infinito'] }
          ]
        },
        hundidos: {
          nombre: 'Hundidos',
          resumen: 'El hueso de la ceja crea sombra en la cuenca.',
          intro: 'Al contrario que los prominentes, tienen el volumen por debajo del hueso superciliar, que crea una sombra muy marcada en la cuenca. Aquí hay que aportar mucha luminosidad.',
          pasos: [
            { pregunta: '¿Cómo equilibrar el volumen del ojo con las sombras?',
              texto: 'Trabaja una cuenca abierta, en tonos claros o medios y siempre bien difuminada. Cualquier línea recta hará que el ojo se hunda más.',
              productos: ['sombra-liquida-one-touch', 'paleta-de-sombras'] },
            { pregunta: '¿Qué acabados funcionan mejor?',
              texto: 'Juega con tonos satinados y brillantes para aportar luminosidad a la mirada.' },
            { pregunta: '¿Qué errores evitar?',
              texto: 'Los colores oscuros, los ahumados muy marcados, marcar las líneas de agua con colores dramáticos y no aportar suficiente luz.' }
          ]
        },
        caidos: {
          nombre: 'Caídos',
          resumen: 'La esquina externa queda por debajo del lagrimal.',
          intro: 'La esquina externa está por debajo del lagrimal, lo que da sensación de cansancio o tristeza. Buscamos elevar la mirada al máximo.',
          pasos: [
            { pregunta: '¿Qué estructura eleva mejor la mirada?',
              texto: 'Un foxy eye, o estructuras que terminen de forma ascendente y empiecen en la parte central del ojo.',
              productos: ['sombra-liquida-one-touch', 'paleta-de-sombras'] },
            { pregunta: '¿Cómo hacer el eyeliner?',
              texto: 'Empieza en la mitad del ojo, muy fino, y ve engrosándolo poco a poco hacia el final. Termina (o, si quieres rabillo, levántalo) en la última pestaña: no bajes hasta el final real del ojo, así parecerá un poco más elevado.' },
            { pregunta: '¿Qué errores evitar?',
              texto: 'Empezar el delineado en la parte interna del ojo, acabarlo por debajo de la línea de pestañas o trabajar estructuras muy redondas.' }
          ]
        }
      }
    },
    labios: {
      titulo: 'Labios',
      subtitulo: 'Perfilado, color y aplicación según la forma del labio',
      tipos: {
        grandes: {
          nombre: 'Grandes',
          resumen: 'Labios con mucho volumen natural.',
          intro: 'Queremos definirlos con color sin aportarles más volumen.',
          pasos: [
            { pregunta: '¿Cómo definirlos sin aportar volumen?',
              texto: 'Un labial Confort&Go aporta color pero no volumen, porque es más bien satinado. Para algo más natural, perfila el labio con un lápiz y difumínalo, para que no quede una línea del todo precisa.',
              productos: ['pintalabios-comfort-go-acido-hialuronico', 'iluminador'] },
            { pregunta: '¿Dónde hacer el perfilado?',
              texto: 'Respeta siempre el borde natural. En este caso, nada de overlip.' },
            { pregunta: '¿Qué acabados y colores funcionan mejor?',
              texto: 'Los acabados satinados o mate en tonos nude.' },
            { pregunta: '¿Cómo conseguir un resultado equilibrado?',
              texto: 'Evita los degradados de color y los labiales muy luminosos para no aportar todavía más volumen.' }
          ]
        },
        finos: {
          nombre: 'Finos',
          resumen: 'Labios con poco volumen.',
          intro: 'Buscamos crear sensación de volumen sin que resulte artificial.',
          pasos: [
            { pregunta: '¿Cómo perfilarlos para dar volumen sin que parezca artificial?',
              texto: 'Perfila justo por encima del borde natural, pero respétalo en las comisuras. Difumina hacia dentro sin cubrir el labio entero.',
              productos: ['lapiz-de-labios-perfilado-sedoso'] },
            { pregunta: '¿Cuánto puedes salir del contorno natural?',
              texto: 'Quédate justo por encima del contorno natural; no te inventes una línea más arriba. Si no, el volumen no irá acorde con el color y se verá artificial.' },
            { pregunta: '¿Dónde aplicar luz para dar más volumen?',
              texto: 'Un poco de iluminador justo en el arco de cupido, un labial más claro que el perfilador en la zona central del labio y un gloss por encima.',
              productos: ['iluminador', 'pintalabios-comfort-go-acido-hialuronico'] },
            { pregunta: '¿Qué texturas favorecen más?',
              texto: 'Las satinadas, los bálsamos y los glosses: al atraer la luz al labio dan sensación de más volumen.',
              productos: ['lip-gloss-melting-plump', 'balsamo-labial-hidratante'] }
          ]
        },
        asimetricos: {
          nombre: 'Asimétricos',
          resumen: 'Un lado (o un labio) más voluminoso que el otro.',
          intro: 'La asimetría no siempre es de lado a lado: también puede ser de arriba abajo. Buscamos igualar sin perder naturalidad.',
          pasos: [
            { pregunta: '¿Cómo corregir la asimetría con el perfilador?',
              texto: 'Fíjate en la parte más voluminosa e intenta recrearla con el perfilador en el lado contrario.',
              productos: ['lapiz-de-labios-perfilado-sedoso'] },
            { pregunta: '¿Cómo igualar ambos lados sin perder naturalidad?',
              texto: 'Respeta los bordes naturales del labio. Si el labio superior es más fino que el inferior, perfila arriba justo por encima del borde natural y abajo quédate justo en él. Si la asimetría es de lado a lado, en el lado más grueso perfila por dentro del borde y en el más fino copia el otro justo por encima del contorno. Tener asimetría no significa poder perfilar como quieras: si exageras, quedará artificial.' },
            { pregunta: '¿Dónde aplicar el color y la luz?',
              texto: 'Aporta luz al centro del labio con un color más clarito que el resto. Ese degradado distrae la mirada del perfil, igual que cuando damos volumen a un labio fino.',
              productos: ['pintalabios-comfort-go-acido-hialuronico', 'lip-gloss-melting-plump'] }
          ]
        }
      }
    }
  },

  // Nombres de las categorías (solo se usan en los pasos sin «productos»)
  categorias: {
    bronceador: 'Bronceador',
    bronceador_frio: 'Bronceador de tono frío',
    colorete: 'Colorete',
    iluminador: 'Iluminador',
    sombras_mate: 'Sombras mate',
    sombras_satinadas: 'Sombras satinadas',
    eyeliner: 'Eyeliner',
    lapiz_ojos: 'Lápiz de ojos',
    perfilador_labios: 'Perfilador de labios',
    labial: 'Labial',
    gloss: 'Gloss y bálsamos'
  }
};
